import React, {Component} from "react";
import Dexie from "dexie";
import {AdaptivityContext} from "../assets/constants";

class VideoWrapper extends Component {

    constructor(props) {
        super(props);
        this.dbName = "PhotoUploadDB";
        this.storeName = "photos";
        this.objectUrl = null;
        this.state = {
            videoUrl: null,
            uploadProgress: null,
            isCheckingLocal: true
        };
        this.db = new Dexie(this.dbName);
        this.db.version(4).stores({
            [this.storeName]: "++id, &filename, uri, destination, uploaded, &createdAt, uploadedAt, serverUrl, bookedTime, uploadProgress"
        });
    }

    async componentDidMount() {
        await this.checkLocalVideo();
        this.progressInterval = setInterval(() => this.checkLocalVideo(), 1000);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.src !== this.props.src) {
            this.revokeObjectUrl();
            this.setState({videoUrl: null, uploadProgress: null, isCheckingLocal: true});
            this.checkLocalVideo();
        }
    }

    componentWillUnmount() {
        if (this.progressInterval) {
            clearInterval(this.progressInterval);
        }
        this.revokeObjectUrl();
    }

    revokeObjectUrl() {
        if (this.objectUrl) {
            URL.revokeObjectURL(this.objectUrl);
            this.objectUrl = null;
        }
    }

    getFilenameFromUrl(url) {
        return (url || '').split('?')[0].split('/').pop();
    }

    async checkLocalVideo() {
        const filename = this.getFilenameFromUrl(this.props.src);

        try {
            const records = await this.db[this.storeName].where('filename').equals(filename).toArray();

            if (records.length > 0 && !records[0].uploaded) {
                // Still in the upload queue: show local blob + progress
                if (!this.objectUrl && records[0].blob) {
                    this.objectUrl = URL.createObjectURL(records[0].blob);
                }
                this.setState({
                    videoUrl: this.objectUrl,
                    uploadProgress: records[0].uploadProgress ?? 0,
                    isCheckingLocal: false
                });
            } else if (this.state.videoUrl !== this.props.src || this.state.uploadProgress !== null || this.state.isCheckingLocal) {
                // Uploaded (queue record deleted) - switch to the server URL
                this.revokeObjectUrl();
                this.setState({
                    videoUrl: this.props.src,
                    uploadProgress: null,
                    isCheckingLocal: false
                });
            }
        } catch (error) {
            console.error('Ошибка при проверке локальной базы данных:', error);
            this.setState({videoUrl: this.props.src, uploadProgress: null, isCheckingLocal: false});
        }
    }

    renderFill() {
        const isUploading = this.state.uploadProgress !== null && this.state.uploadProgress < 100;

        if (this.state.isCheckingLocal || !this.state.videoUrl) {
            return <div className="angle-tile__cover-empty" aria-hidden="true"/>;
        }

        return (
            <div className="video-wrapper--fill" style={{position: 'relative', width: '100%', height: '100%'}}>
                <video src={this.state.videoUrl} muted playsInline preload="metadata"/>
                {isUploading &&
                    <div className="photo-wrapper--fill-progress">
                        {this.state.uploadProgress}%
                    </div>}
            </div>
        );
    }

    render() {
        if (this.props.fill) {
            return this.renderFill();
        }

        const width = this.props.width ?? (AdaptivityContext.isMobile ? 260 : 400);
        const isUploading = this.state.uploadProgress !== null && this.state.uploadProgress < 100;

        if (this.state.isCheckingLocal || !this.state.videoUrl) {
            return (
                <div style={{
                    width,
                    height: Math.round(width * 0.56),
                    borderRadius: 8,
                    backgroundColor: '#f0f0f0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#999',
                    ...this.props.style
                }}>...</div>
            );
        }

        return (
            <div style={{position: 'relative', display: 'inline-block', ...this.props.style}}>
                <video
                    src={this.state.videoUrl}
                    controls
                    preload="metadata"
                    playsInline
                    width={width}
                    style={{borderRadius: 8, display: 'block', maxWidth: '100%'}}
                />
                {isUploading && (
                    <div style={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        background: 'rgba(0, 0, 0, 0.6)',
                        color: '#fff',
                        borderRadius: 12,
                        padding: '2px 10px',
                        fontSize: 13,
                        fontWeight: 'bold',
                        pointerEvents: 'none'
                    }}>
                        Загрузка {this.state.uploadProgress}%
                    </div>
                )}
            </div>
        );
    }
}

export default VideoWrapper;
